import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsAuthorCard_Box_1 = styled.div`
  margin-top: 16px;
  flex: 3;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    margin-top: 0;
  }
`;

export const CmsAuthorCard_Box_2 = styled.div`
  flex-direction: column;
  text-align: left;
  align-items: flex-start;
  padding: ${gutterWidth / 2}px;
  border-radius: 16px;
  background: ${colors.backgroundGrey};
  display: flex;
  margin-bottom: 70px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    flex-direction: row;
    text-align: left;
    align-items: flex-start;
    padding: ${gutterWidth}px;
    border-radius: 32px;
  }

  &[data-full-width-layout] {
    text-align: center;
    align-items: center;

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      text-align: left;
      align-items: flex-start;
    }
  }
`;
